import { CompareActionTypes, ProductRecentlyViewedActionTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { updateWishListProducts, initializeWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
export const initialProductRecentlyViewedState = [];
export const productRecentlyViewedReducer = (state = initialProductRecentlyViewedState, action) => {
    switch (action.type) {
        case ProductRecentlyViewedActionTypes.FETCH:
            return action.payload;
        case ProductRecentlyViewedActionTypes.ERASE:
            return initialProductRecentlyViewedState;
        case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
            return toggleComparedStateForItems(state, action.payload);
        case WishListActionTypes.UPDATE_PRODUCTS:
            return initializeWishListProducts(state, action);
        case WishListActionTypes.ADD_PRODUCT:
            return updateWishListProducts(state, action, true);
        case WishListActionTypes.REMOVE_PRODUCT:
            return updateWishListProducts(state, action, false);
        case ProductRecentlyViewedActionTypes.SET_DELIVERY_PROMISE:
            return setDeliveryPromiseToProducts(state, action.payload);
        default:
            return state;
    }
};
